import React from 'react';
import './IOSInstallPrompt.css';
import { PWA_INSTALL_APP_ICON } from '../utils/pwaInstallAssets';

const IOSInstallPrompt = ({ onClose }) => {
  return (
    <div className="ios-install-overlay" onClick={onClose}>
      <div className="ios-install-modal" onClick={(e) => e.stopPropagation()}>
        <button className="ios-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        
        <div className="ios-modal-content">
          <div className="ios-modal-header">
            <div className="ios-app-icon">
              <img src={PWA_INSTALL_APP_ICON} alt="Vardaan Global" width="80" height="80" />
            </div>
            <h2>Install on iPhone / iPad</h2>
            <p className="ios-modal-subtitle">Add Vardaan Global to your home screen</p>
          </div>

          <div className="ios-install-steps">
            <div className="ios-step">
              <div className="ios-step-number">1</div>
              <div className="ios-step-content">
                <h3>Tap the Share button</h3>
                <p>Look for the <span className="ios-share-icon">
                  <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
                    <path d="M10 0L10 14M10 0L6 4M10 0L14 4" stroke="#007AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <rect x="0" y="14" width="20" height="8" rx="2" stroke="#007AFF" strokeWidth="2"/>
                  </svg>
                </span> icon at the bottom of your screen</p>
              </div>
            </div>

            <div className="ios-step">
              <div className="ios-step-number">2</div>
              <div className="ios-step-content">
                <h3>Scroll and find "Add to Home Screen"</h3>
                <p>Look for the <span className="ios-add-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <rect x="1" y="1" width="16" height="16" rx="3" stroke="#007AFF" strokeWidth="2"/>
                    <path d="M9 5V13M5 9H13" stroke="#007AFF" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </span> icon with the text</p>
              </div>
            </div>

            <div className="ios-step">
              <div className="ios-step-number">3</div>
              <div className="ios-step-content">
                <h3>Tap "Add" to confirm</h3>
                <p>The app will appear on your home screen</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IOSInstallPrompt;

